import { CompleteProfileDto, UserDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

import { getAnalyticsContext } from "@/client/analytics/context";
import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";

export const completeProfile = async (data: CompleteProfileDto) => {
  data = { ...data, analyticsContext: await getAnalyticsContext() };
  const response = await axios.post<UserDto, AxiosResponse<UserDto>, CompleteProfileDto>(
    "/auth/complete-profile",
    data,
  );

  return response.data;
};

export const useCompleteProfile = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setUser = useAuthStore((state) => state.setUser);

  const redirectTo = searchParams.get("redirect") || "/dashboard";

  const {
    error,
    isPending: loading,
    mutateAsync: completeProfileFn,
  } = useMutation({
    mutationFn: completeProfile,
    onSuccess: (user) => {
      setUser(user);
      queryClient.setQueryData(["user"], user);
      navigate(redirectTo);
    },
  });

  return { completeProfile: completeProfileFn, loading, error };
};
